module.exports = __webpack_public_path__ + "media/images/proof_links/proof_green/facebook-d2669f3754269d87940dec95f8fed0cb.svg";